"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var converterUtil_1 = require("./converterUtil");
var word_mapping_1 = require("./word-mapping");
var Number2Words = (function (_super) {
    __extends(Number2Words, _super);
    function Number2Words(props) {
        var _this = _super.call(this, props) || this;
        _this.getWords = function () {
            var value = _this.props.value;
            var system = _this.props.system || 'international';
            var language = system !== 'hinduArabic' ? 'en' : _this.props.language || 'en';
            var util = new converterUtil_1.ConverterUtil(value, word_mapping_1.WORD_MAPPING[system][language].tenths, word_mapping_1.WORD_MAPPING[system][language].subHundreds, word_mapping_1.WORD_MAPPING[system][language].maxValue, word_mapping_1.WORD_MAPPING[system][language].decimalWord, word_mapping_1.WORD_MAPPING[system][language].negativeWord);
            return util.getWords();
        };
        _this.state = {
            words: _this.getWords()
        };
        return _this;
    }
    Number2Words.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.value !== this.props.value ||
            prevProps.system !== this.props.system ||
            prevProps.language !== this.props.language) {
            this.setState({
                words: this.getWords()
            });
        }
    };
    Number2Words.prototype.render = function () {
        var words = this.state.words;
        return (React.createElement("span", { className: "number2words__container" }, words));
    };
    return Number2Words;
}(React.Component));
exports.default = Number2Words;
//# sourceMappingURL=Number2Words.js.map